import { render } from "./taskDesk.vue?vue&type=template&id=204fd224&scoped=true"
import script from "./taskDesk.vue?vue&type=script&lang=js"
export * from "./taskDesk.vue?vue&type=script&lang=js"

import "./taskDesk.vue?vue&type=style&index=0&id=204fd224&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-204fd224"

export default script